import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import { getUrlLangPrefix } from "@/utils/Local";

import BannerComponent from "../components/Banner.component";
import BreadcrumbComponent, {
  buildBreadcrumbJsonLd,
} from "../components/Breadcrumb.component";
import DocumentComponent from "../components/Document.component";
import EventsComponent from "../components/Events.component";
import ScheduleComponent from "../components/Schedule.component";
import i18n from "../i18n";

const Events = () => {
  const { t } = i18n;
  const langPrefix = getUrlLangPrefix();

  const breadcrumbs = [
    { label: t("gallery"), to: `${langPrefix}/${t("_route.gallery")}` },
    { label: t("Events") },
  ];

  return (
    <React.Fragment>
      <DocumentComponent
        jsonLd={buildBreadcrumbJsonLd(breadcrumbs)}
        title={t("Events")}
      />
      <BreadcrumbComponent items={breadcrumbs} />
      <BannerComponent description="" title={t("Events")} />
      <Container className="mb-5 galleryContainer">
        <EventsComponent />
      </Container>

      <ScheduleComponent />
    </React.Fragment>
  );
};

export default Events;
